require('angular').module('oly.common')
    .factory('GoogleMapsApi', ['$q', 'ResourceInjector', 'SettingsService', require('./google-maps-api-factory')])
    .directive('olyGoogleMap', [require('./google-map.directive').googleMapDirectiveDefinition])
    .directive('olyGoogleMapMarker', [require('./google-marker.directive').googleMarkerDirectiveDefinition])
    .directive('olyGoogleInfoWindow', [require('./google-info-window.directive').googleInfoWindowDirectiveDefinition])
    .directive('olyGoogleDirectionsRenderer', [require('./google-directions-renderer.directive').googleDirectionsRendererDirectiveDefinition])
    .directive('olyGoogleMapGeocenter', [require('./google-map-geocenter.directive').googleMapGeocenterDirectiveDefinition])
    .directive('olyPlacesAutocomplete', [require('./google-places-autocomplete.directive').googlePlacesAutocompleteDirectiveDefinition]);



// WEBPACK FOOTER //
// ./src/olycommon/googlemaps/index.js